import { render, staticRenderFns } from "./NewVolatilityAndReturnsArea.vue?vue&type=template&id=ffd938aa&scoped=true&"
import script from "./NewVolatilityAndReturnsArea.vue?vue&type=script&lang=js&"
export * from "./NewVolatilityAndReturnsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd938aa",
  null
  
)

export default component.exports